module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.screenTrack[0] >= 2) ? _c('router-link', {
    staticClass: "rout-bot bot-left hvr-grow",
    attrs: {
      "aria-label": "Página anterior",
      "to": _vm.linksPath + (_vm.screenTrack[0] - 1)
    },
    nativeOn: {
      "click": function($event) {
        _vm.guardarubicacion()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fddb121","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/NavAtras.vue
// module id = 1036
// module chunks = 1